export interface TypeCalculationParams {
  minPrice: number
  proposedPrice: number
}

export function calculateType(
  params: TypeCalculationParams
): 'error' | 'success' {
  const { minPrice, proposedPrice } = params

  return Math.round(proposedPrice) >= Math.round(minPrice) ? 'success' : 'error'
}
